import { useAnalytics } from "@/hooks/useAnalytics";

/**
 * Analytics Provider Component
 * Handles analytics tracking within Router context
 * This ensures useLocation() works properly
 */
const AnalyticsProvider = () => {
  // Initialize analytics tracking
  useAnalytics();
  
  // This component doesn't render anything
  return null;
};

export default AnalyticsProvider;